export default __webpack_public_path__ + "static/logo-telmotor-black-2b14e96d97967e293100a5ac0f6349ed.svg";